
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/[id]",
      function () {
        return require("private-next-pages/projects/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/[id]"])
      });
    }
  